import {
  ADD_ANNOTATION_BEGUN,
  ADD_ANNOTATION_SUCCESS,
  ADD_ANNOTATION_FAILIURE,
  MODIFY_ANNOTATION_BEGUN,
  MODIFY_ANNOTATION_SUCCESS,
  MODIFY_ANNOTATION_FAILIURE,
  GET_XFDF_BEGUN,
  GET_XFDF_SUCCESS,
  GET_XFDF_FAILIURE,
  POSSIBLE_EVIDENCE_OPEN,
  POSSIBLE_EVIDENCE_CLOSE,
} from "@safecv/actions/types";

const initialState = {
  loading: false,
  xfdfLoader: false,
  getxfdfData: null,
  isPossibleEvidenceModalClose: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_ANNOTATION_BEGUN:
      return {
        ...state,
        loading: true,
      };
    case ADD_ANNOTATION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ADD_ANNOTATION_FAILIURE:
      return {
        ...state,
        loading: false,
      };
    case MODIFY_ANNOTATION_BEGUN:
      return {
        ...state,
        loading: true,
      };
    case MODIFY_ANNOTATION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case MODIFY_ANNOTATION_FAILIURE:
      return {
        ...state,
        loading: false,
      };
    case GET_XFDF_BEGUN:
      return {
        ...state,
        getxfdfData: null,
        xfdfLoader: true,
      };
    case GET_XFDF_SUCCESS:
      return {
        ...state,
        getxfdfData: action.payload,
        xfdfLoader: false,
      };
    case GET_XFDF_FAILIURE:
      return {
        ...state,
        getxfdfData: null,
        xfdfLoader: false,
      };
    case POSSIBLE_EVIDENCE_OPEN:
      return {
        ...state,
        isPossibleEvidenceModalClose: false,
      };
    case POSSIBLE_EVIDENCE_CLOSE:
      return {
        ...state,
        isPossibleEvidenceModalClose: true,
      };
    default:
      return state;
  }
}
